// @ts-nocheck
import angular from 'angular';
import crypto from 'crypto-js';
import { conformToMask } from 'vanilla-text-mask';
import _ from 'lodash-es';

// eslint-disable-next-line unicorn/no-static-only-class
export default class Utils {
	static checkEmail(email) {
		return /^(([^\s"(),.:;<>@[\\\]]+(\.[^\s"(),.:;<>@[\\\]]+)*)|(".+"))@((\[(?:\d{1,3}\.){3}\d{1,3}])|(([\dA-Za-z-]+\.)+[A-Za-z]{2,}))$/.test(String(email).toLowerCase());
	}

	static JSONParseSafe(string_) {
		if (
			string_ === undefined
			|| string_ === null
			|| string_ === ''
			|| typeof string_ !== 'string'
		) {
			// eslint-disable-next-line no-param-reassign
			string_ = '{}';
		}

		try {
			return JSON.parse(string_);
		}
		catch {
			return null;
		}
	}

	static download(data, type, filename, newTab = false) {
		const blob = typeof window.File === 'function'
			? new window.File([data], filename, { type }) : new window.Blob([data], { type });

		if (window.navigator.msSaveBlob === undefined) {
			const URL = window.URL || window.webkitURL;
			const downloadUrl = URL.createObjectURL(blob);

			if (filename) {
				// use HTML5 a[download] attribute to specify filename
				const a = document.createElement('a');
				// safari doesn't support this yet
				if (a.download === undefined) {
					if (newTab) {
						window.open(downloadUrl, '_blank');
					}
					else {
						window.location.replace(downloadUrl);
					}
				}
				else {
					a.href = downloadUrl;
					a.download = filename;
					document.body.append(a);
					a.click();
				}
			}
			else if (newTab) {
				window.open(downloadUrl, '_blank');
			}
			else {
				window.location.replace(downloadUrl);
			}

			// eslint-disable-next-line angular/timeout-service
			window.setTimeout(() => {
				URL.revokeObjectURL(downloadUrl);
			}, 100); // cleanup
		}
		else {
			// IE workaround for "HTML7007: One or more blob URLs were revoked by closing the blob for which they
			// were created. These URLs will no longer resolve as the data backing the URL has been freed."
			window.navigator.msSaveBlob(blob, filename);
		}
	}

	static encodeHTMLEntities(text) {
		const textArea = document.createElement('textarea');
		textArea.textContent = text;
		return textArea.innerHTML;
	}

	static encodeKParam(order, token, body) {
		const object = JSON.stringify(body);
		const key = `${order}${token}`.slice(0, 32).padEnd(32, 'K');
		const iv = `${token}${order}`.slice(0, 16).padEnd(16, 'K');

		try {
			return crypto.AES.encrypt(object, crypto.enc.Utf8.parse(key), {
				iv: crypto.enc.Utf8.parse(iv),
			}).toString();
		}
		catch (error) {
			console.error(error);
			return null;
		}
	}

	static formatNumber(number, mask) {
		// eslint-disable-next-line no-param-reassign
		number = (number || 0).toString();
		return conformToMask(number, mask(number).filter(item => item !== '[]')).conformedValue;
	}

	static getCurrencyAffixes({
		currency = 'EUR',
		decimalLimit,
		decimalSeparator,
		lang = 'fr',
	}) {
		// Get the prefix and suffix from the localized string.
		let regex = '(.*)?100';

		if (decimalLimit) {
			regex += `${decimalSeparator === '.' ? '\\.' : decimalSeparator}0{${decimalLimit}}`;
		}

		regex += '(.*)?';

		const parts = (100).toLocaleString(lang, {
			style: 'currency',
			currency,
			useGrouping: true,
			maximumFractionDigits: decimalLimit,
			minimumFractionDigits: decimalLimit,
		}).replace(/[,.]/, decimalSeparator).match(new RegExp(regex));

		return {
			prefix: parts[1] || '',
			suffix: parts[2] || '',
		};
	}

	static getNumberSeparators(...arguments_) {
		const lang = arguments_.length > 0 && arguments_[0] !== undefined ? arguments_[0] : 'en';
		const formattedNumberString = 12_345.6789.toLocaleString(lang);
		const delimeters = formattedNumberString.match(/..(.)...(.)../);

		if (!delimeters) {
			const numberWithDecimalSeparator = 1000.1;
			const groups = Intl.NumberFormat(navigator.language).formatToParts(numberWithDecimalSeparator);

			return {
				thousandsSeparator: groups.find(part => part.type === 'group').value,
				radix:              groups.find(part => part.type === 'decimal').value,
			};
		}

		return {
			thousandsSeparator: delimeters.length > 1 ? delimeters[1] : ',',
			radix:              delimeters.length > 2 ? delimeters[2] : '.',
		};
	}

	static getStackTrace() {
		const o = {};
		Error.captureStackTrace(o, this.getStackTrace);
		return o.stack;
	}

	static guid() {
		return `${
			Utils.s4() + Utils.s4()
		}-${
			Utils.s4()
		}-${
			Utils.s4()
		}-${
			Utils.s4()
		}-${
			Utils.s4() + Utils.s4() + Utils.s4()
		}`;
	}

	static htmlDecode(input) {
		const d = new DOMParser().parseFromString(input, 'text/html');
		return d.documentElement.textContent;
	}

	/**
	 * @returns {boolean}
	 * @deprecated
	 */
	static isMobile() {
		return angular.element(window).width() <= 767;
	}

	static isoDate(date = new Date()) {
		const timezoneOffset = date.getMinutes() + date.getTimezoneOffset();
		const timestamp = date.getTime() - timezoneOffset * 60 * 1000;
		const correctDate = new Date(timestamp);

		correctDate.setUTCHours(0, 0, 0, 0);
		return correctDate.toISOString().slice(0, 10);
	}

	/**
	 * Fonction qui decode une chaine de caractère selon un filtre K1
	 *
	 * @param {string} mdp
	 * @returns {string}
	 * @example
	 * $decrypt=k1_decode('_K1_I3S533M3H');
	 */
	static k1Decode(mdp) {
		let result = '';
		const tLettre = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';

		if (Utils.strncmp(mdp, '_K1_', 4) === 0 && mdp !== '') {
			let vRand = mdp[5];
			const vPos = tLettre.indexOf(vRand);
			if (vPos === -1) {
				return '';
			}
			vRand = vPos;
			let vDecal = 0;
			let vPosition;
			let highValue;
			let lowValue;
			for (let index = 6; index < mdp.length;) {
				const highCar = mdp[index];
				const lowCar = mdp[index + 1];
				index += 2;
				vPosition = tLettre.indexOf(highCar);
				if (vPosition === -1) {
					return '';
				}
				highValue = vPosition;

				vPosition = tLettre.indexOf(lowCar);
				if (vPosition === -1) {
					return '';
				}
				lowValue = vPosition;

				// eslint-disable-next-line no-bitwise,no-mixed-operators
				const newValue2 = highValue << 4 | lowValue; // jshint ignore:line
				// eslint-disable-next-line no-bitwise
				let newValue = ~(newValue2 ^ vRand); // jshint ignore:line
				newValue = ~newValue; // jshint ignore:line

				let vOrd
					// eslint-disable-next-line no-mixed-operators,no-bitwise
					= (newValue & 0x03) << 6
					// eslint-disable-next-line no-mixed-operators,no-bitwise
					| (newValue & 0x0C) >> 2
					// eslint-disable-next-line no-mixed-operators,no-bitwise
					| (newValue & 0x30) >> 2
					// eslint-disable-next-line no-mixed-operators,no-bitwise
					| (newValue & 0xC0) >> 2;

				vOrd -= vDecal;
				result += String.fromCodePoint(vOrd);
				vDecal++;
				if (vDecal > 12) {
					vDecal = 0;
				}
			}
		}

		return result;
	}

	/**
	 * Fonction qui encode une chaine de caractère selon un filtre K1
	 *
	 * @param {string} mdp
	 * @returns {string}
	 * @example
	 *   $crypt=k1_encode('2016-02-22 14:27:12');
	 */
	static k1Encode(mdp) {
		const tLettre = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';
		const vRand = Math.floor(Math.random() * 36);
		const vRand2 = Math.floor(Math.random() * 36);

		let vDecal = 0;
		let result = mdp.trim();

		if (Utils.strncmp(mdp, '_K1_', 4) !== 0 && mdp !== '') {
			result = tLettre[vRand2] + tLettre[vRand];

			for (const vCar of mdp) {
				const vOrd = vCar.codePointAt(0) + vDecal;
				const da = vOrd & 0x03; // jshint ignore:line
				const database = vOrd & 0x0C; // jshint ignore:line
				const dc = vOrd & 0x30; // jshint ignore:line
				const dd = vOrd & 0xC0; // jshint ignore:line
				// eslint-disable-next-line no-bitwise
				const newValue = ~((dd >> 6) | (database << 2) | (da << 2) | (dc << 2)); // jshint ignore:line
				// eslint-disable-next-line no-bitwise
				const newValue2 = ~(newValue ^ vRand); // jshint ignore:line
				// eslint-disable-next-line no-bitwise
				const highValue = (newValue2 & 0xF0) >> 4; // jshint ignore:line
				const lowValue = (newValue2 & 0x0F);
				result += tLettre[highValue];
				result += tLettre[lowValue];
				vDecal++;
				if (vDecal > 12) {
					vDecal = 0;
				}
			}
			result = `_K1_${result}`;
		}

		return result;
	}

	/**
	 * @param {any} unordered
	 * @returns {any}
	 * @deprecated
	 */
	static ksort(unordered) {
		if (!angular.isObject(unordered)) {
			// Not to sort the array
			return unordered;
		}

		const ordered = {};
		for (const key of Object.keys(unordered).sort()) {
			ordered[key] = unordered[key];
		}

		return ordered;
	}

	/**
	 * @param {string} stringDate
	 * @returns {Date|string}
	 */
	static parseDate(stringDate) {
		const dateParser = /(\d{2})\/(\d{2})\/(\d{4})( (\d{2}):(\d{2}):(\d{2}))?/;
		const match = stringDate.match(dateParser);
		return match.at(4)
			? new Date(
				Number.parseInt(match[3], 10), // year
				Number.parseInt(match[2], 10) - 1, // monthIndex
				Number.parseInt(match[1], 10), // day
				Number.parseInt(match[5], 10), // hours
				Number.parseInt(match[6], 10), // minutes
				Number.parseInt(match[7], 10), // seconds
			) : `${match[3]}-${match[2] - 1}-${match[1]}`;
	}

	/**
	 * @param {any} originalPath
	 * @returns {any}
	 */
	static reversePath(originalPath) {
		const path = _.cloneDeep(originalPath).map(p => {
			p.flow = p.flow === 'up' ? 'down' : (p.flow === 'down' ? 'up' : null);
			return p;
		});
		path.reverse();
		for (const [index, p] of path.entries()) {
			if (index > 0) {
				p.flow = path[index - 1].flow;
			}
		}
		path[0].flow = null;
		return path;
	}

	static s4() {
		return Math.floor((1 + Math.random()) * 0x1_00_00).toString(16).slice(1);
	}

	static shuffle(a) {
		for (let index = a.length - 1; index > 0; index--) {
			const index2 = Math.floor(Math.random() * (index + 1));
			[
				a[index],
				a[index2],
			] = [
				a[index2],
				a[index],
			];
		}
		return a;
	}

	/**
	 * @param {string} string
	 * @returns {number}
	 */
	static stringHash(string) {
		let hash = 5381;
		let index = string.length;

		while (index) {
			// eslint-disable-next-line no-bitwise
			hash = (hash * 33) ^ string.codePointAt(--index);
		}

		/* JavaScript does bitwise operations (like XOR, above) on 32-bit signed
		 * integers. Since we want the results to be always positive, convert the
		 * signed int to an unsigned by doing an unsigned bitshift. */
		// eslint-disable-next-line no-bitwise,no-unused-expressions
		return hash >>> 0;
	}

	/**
	 * Strips tags in a string
	 *
	 * @param {string} string String to strip tags
	 * @returns {string} The string stripped
	 */
	static stripTags(string) {
		return typeof string === 'string' ? string.replaceAll(/(<([^>]+)>)/gi, '') : '';
	}

	static strncmp(string1, string2, lgth) {
		const s1 = (`${string1}`).slice(0, Math.max(0, lgth));
		const s2 = (`${string2}`).slice(0, Math.max(0, lgth));

		return ((s1 === s2) ? 0 : ((s1 > s2) ? 1 : -1));
	}

	/**
	 * Set first letter uppercase
	 *
	 * @param {[string, ...string]} param
	 * @param {string} [locale]
	 * @returns {string}
	 */
	static ucfirst([first, ...rest], locale = navigator.language) {
		return [first.toLocaleUpperCase(locale), ...rest].join('');
	}
}
